import { css, palette, space } from 'bumbag';
import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';

var _templateObject, _templateObject2, _templateObject3;
var SelectMenu = {
  Button: {
    styles: {
      base: function base(styleProps) {
        return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        &&[aria-expanded='true'],\n        &&:focus {\n          border-color: ", ";\n          box-shadow: ", " 0px 0px 0px 1px !important;\n        }\n\n        ", ";\n      "])), palette('primary')(styleProps), palette('primary')(styleProps), styleProps.state && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n          & {\n            border-color: ", ";\n            box-shadow: ", " 0px 0px 0px 1px !important;\n          }\n        "])), palette(styleProps.state)(styleProps), palette(styleProps.state)(styleProps)));
      }
    }
  },
  Icon: {
    styles: {
      base: function base(styleProps) {
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n        height: ", "em;\n      "])), space(11)(styleProps));
      }
    }
  }
};

export default SelectMenu;
